var EvaluationService = require('services/evaluation-service');
var utils = require('lib/utils');

var AssessmentService = function () {
  this.getRedirectUrlForCurrentPage = function () {
    var currentPage = EF.module.currentActivity.currentPage;
    var redirectUrl = '#' + currentPage.path() + '?assessmentTaken=true';
    return redirectUrl;
  };

  this.triggerAssessment = function (blockView) {
    var redirectUrl = this.getRedirectUrlForCurrentPage();
    var data = {
      event_type: 'assessment-initialized',
      redirectUrl: redirectUrl,
      slug: blockView.model.get('assessment_slug'),
    };
    window.postMessage(data, window.location.origin);
  };

  this.userHasCompletedAssessment = function (courseSlug) {
    return EvaluationService.userHasPassedEvaluation(courseSlug);
  };

  this.getBestScore = function (courseSlug) {
    return EvaluationService.bestScore(courseSlug);
  };

  this.loadCourseAssessment = function (view) {
    return new Promise(resolve => {
      EvaluationService.expandedResponseSet(view.model.get('assessment_slug')).then(() => {
        const evaluation = EvaluationService.findEvaluationBySlug(view.model.get('assessment_slug'));
        const responseSet = EvaluationService.getResponseSetFromModel(view.model.get('assessment_slug'));

        const sections = evaluation.get('sections');
        const questions = new EF.Collections.Assessments.QuestionsCollection(
          sections.reduce((result, section) => {
            return result.concat(section.questions);
          }, [])
        );
        view.assessment.set('questions', questions);
        view.assessment.set('original_questions', questions);
        view.assessment.set('response_set', responseSet);

        const attempt = new EF.Models.Assessments.Attempt(1, { assessment: view.assessment });

        attempt.set({
          id: responseSet.id,
          token: EvaluationService.findEvaluationTokenBySlug(view.model.get('assessment_slug')),
        });
        view.assessment.set('attempt', attempt);

        resolve(view);
      });
    });
  };

  this.getUrl = function (assessment, isSaving) {
    const includes = isSaving ? '' : '?include=evaluation,sections.questions.answers';
    return `${assessment.get('response_set').endpoint}/response_sets/${
      assessment.get('response_set').id
    }.json${includes}`;
  };

  this.isAttemptCorrect = function (results, questionId) {
    if (Array.isArray(results.incorrect_answers)) {
      return !results.incorrect_answers.some(ia => ia.question_id === questionId);
    }
  };

  this.getAssessmentStatus = function (courseSlug) {
    var attempts = this.getResponseSetForSlug(courseSlug);
    if (attempts.length === 0) {
      return 'not-attempted';
    } else if (
      _.every(attempts, function (ap) {
        return !ap.get('passed');
      })
    ) {
      return 'failed';
    } else if (
      _.some(attempts, function (ap) {
        return ap.get('passed');
      })
    ) {
      return 'passed';
    }
  };

  this.getResponseSetId = function (courseSlug, mapping) {
    var response = mapping[courseSlug];
    if (response) {
      return response;
    } else {
      console.warn('Invalid assessment mapping for slug: ', courseSlug); //eslint-disable-line no-console
      console.warn('Here are the configured assessment mappings for reference: ', mapping); //eslint-disable-line no-console
      // trigger something special...
    }
  };

  this.getResponseSetForSlug = function (courseSlug, mapping) {
    var response = this.getResponseSetId(courseSlug, mapping);
    return EF.responseSet.filter(function (rs) {
      return rs.get('id') === response.id;
    });
  };

  this.getActivityProgressForSlug = function () {};

  this.isAttemptComplete = function (attempt) {
    var answers = $.map(attempt.get('answers'), function (answer) {
      return answer.question_id;
    });
    var questions = attempt.assessment.get('original_questions') || attempt.assessment.get('questions');
    return questions.every(function (q) {
      return $.inArray(q.get('id'), answers) >= 0;
    });
  };

  this.isAttemptFinished = function (attempt) {
    return attempt.get('status') == 'completed';
  };
  this.parseAttempt = function (data) {
    if (data && data.data) {
      return utils.sanifyJsonApiObject(data.data, data.included);
    } else {
      return data;
    }
  };

  this.refreshActivityProgress = function () {};

  this.getAttemptJSON = function (thisAttempt) {
    return {
      data: {
        id: thisAttempt.get('id'),
        type: 'response_sets',
        attributes: {
          answers: [
            {
              question_id: thisAttempt.get('current_question_id'),
              value: thisAttempt.get(thisAttempt.get('current_question_id')),
              response_type: 'single_selection',
            },
          ],
        },
      },
    };
  };
};

module.exports = new AssessmentService();
